import React, { useEffect, useState } from "react";
import useStyles from "../common/Styles";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import agricultureMap from "../../../../assets/Water_User_Agriculture.json";
import { useSelector } from "react-redux";
import { Box } from "@material-ui/core";
import { usePrevious } from "components/common/usePrevious";
// import userActions from "../common/actions";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";

var map;
var allModelLayer;
var legend;

// const includedDistricts = {
//   "New Magma Irrigation and Drainage District": true,
//   "Roosevelt Irrigation District": true,
//   "Roosevelt Water Conservation District": true,
//   "Central Arizona Irrigation and Drainage District": true,
//   "Maricopa Water District": true,
//   "Queen Creek Irrigation Water Delivery District": true,
//   "Hohokam Irrigation and Drainage District": true,
//   "Maricopa-Stanfield Irrigation and Drainage District": true,
//   "Cortaro-Marana Water Users Association": true,
//   "San Carlos Irrigation and Drainage District": true,
//   "Tonopah Irrigation District": true,
//   "Salt River Valley Water Users Association": true,
//   "Buckeye Water Conservation and Drainage District": true,
//   "Mohave Valley Irrigation and Drainage District": true,
//   "Mohave Water Conservation District": true,
//   "Cibola Valley Irrigation and Drainage District": true,
//   "Wellton-Mohawk Irrigation and Drainage District": true,
//   "Yuma Mesa Irrigation and Drainage District": true,
//   "Yuma Irrigation and Drainage District": true,
//   "North Gila Valley Irrigation and Drainage District": true,
//   "Unit B Irrigation and Drainage District": true,
//   "Hillander-C Irrigation and Drainage District": true,
//   "Sturgest Gila Monster Ranch": true,
//   "Yuma County Water Users Association": true,
//   "Avra Valley Irrigation District": true,
//   "BKW Farms": true,
//   "Farmers Investment Company": true,
// };
const includedDistricts = {
  "BKW Farms": true,
  "Buckeye Water Conservation and Drainage District": true,
  "Central Arizona Irrigation and Drainage District": true,
  "Cortaro-Marana Water Users Association": true,
  "Farmers Investment Company": true,
  "Hohokam Irrigation and Drainage District": true,
  "Kai Farms": true,
  "Maricopa Water District": true,
  "Maricopa-Stanfield Irrigation and Drainage District": true,
  "New Magma Irrigation and Drainage District": true,
  "Queen Creek Irrigation District": true,
  "Roosevelt Irrigation District": true,
  "Roosevelt Water Conservation District": true,
  "Salt River Valley Water Users Association": true,
  "Tonopah Irrigation District": true,
};

const includedDistrictColor = {
  fillColor: "#699EE0",
  fillOpacity: 0.5,
  weight: 1,
  color: "#707070",
};

const notIncludedDistrictColor = {
  fillColor: "#C9C9C9",
  fillOpacity: 0.5,
  weight: 1,
  color: "#707070",
};

function AgricultureMap() {
  const classes = useStyles();
  // const { setWaterUserOption } = userActions();
  const { toggle_about, agriculture_selected } =
    useSelector((state) => state.water_user);
  const [selectedFeature, setSelectedFeature] = useState(null);
  const previousFeature = usePrevious(selectedFeature);
  const { isMobile } = useGetViewPortDimensions();

  // useEffect(() => {
  //   setWaterUserOption(agriculture);
  // }, [agriculture]);

  const onEachFeature = (feature, layer) => {
    layer
      .setStyle(
        includedDistricts.hasOwnProperty(feature.properties.LONG_NAME)
          ? includedDistrictColor
          : notIncludedDistrictColor
      )
      .bindTooltip(feature.properties.LONG_NAME, { direction: "top" })
      .openTooltip();

    if (feature.properties.LONG_NAME.includes(agriculture_selected.name)) {
      highlightFeature(layer);
      setSelectedFeature(layer);
    }
  };

  const highlightFeature = (layer) => {
    // let layer = e.target;
    layer.setStyle({
      weight: 3,
      color: "#3559C8",
    });

    if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
      layer.bringToFront();
    }

    map.setView(
      new L.LatLngBounds(
        new L.LatLng(
          layer._bounds._northEast.lat,
          layer._bounds._northEast.lng
        ),
        new L.LatLng(layer._bounds._southWest.lat, layer._bounds._northEast.lng)
      ).getCenter(),
      10
    );
  };

  const generateMap = () => {
    if (map) {
      map.remove();
    }
    map = L.map("map", {
      center: new L.LatLngBounds(
        new L.LatLng(30, -113),
        new L.LatLng(37, -111.2)
      ).getCenter(),
      zoomControl: false,
      doubleClickZoom: true,
      scrollWheelZoom: true,
      zoom: 8,
      maxZoom: 10,
      // maxZoom: 11,
      minZoom: 6,
      maxBounds: [
        //south-west coordinates
        [30, -115],
        //north-east coordinates
        [40, -100.0],
      ],
      maxBoundsViscosity: 1.0,
      layers: [
        L.tileLayer(
          "https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png",
          {
            noWrap: true,
            attribution:
              '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            subdomains: "abcd",
          }
        ),
      ],
    });
    // add zoom control
    L.control
      .zoom({
        position: "topright",
      })
      .addTo(map);

    if (allModelLayer) {
      allModelLayer.remove();
    }
    allModelLayer = L.geoJSON(agricultureMap, {
      onEachFeature,
    }).addTo(map);
  }
  useEffect(generateMap, [toggle_about]);

  const setAgriculture = () => {
    if (allModelLayer) {
      allModelLayer.remove();
    }
    allModelLayer = L.geoJSON(agricultureMap, {
      onEachFeature,
    }).addTo(map);
  }
  useEffect(setAgriculture, [agriculture_selected]);

  const generateDOM = () => {
    if (legend) {
      legend.remove();
    }
    legend = L.control({ position: "topleft" });
    legend.onAdd = function (map) {
      var div = L.DomUtil.create("div", "infoCity legend");
      // div.innerHTML += `<div style="padding: 18px 0px 18px 0px" class='legendTitle'> </div>`;
      // TODO: if city adds title, use same styling as industry, else use infoCity class for styling using flex
      div.innerHTML += `<div class = 'labelGroup'><i style="background:#699EE0"></i><span class='legendLabel'>Lorem ipsum</span></div>`;
      div.innerHTML += `<div class = 'labelGroup'><i style="background:#9F9F9F"></i><span class='legendLabel'>No data</span></div>`;
      return div;
    };
    legend.addTo(map);
  }
  useEffect(generateDOM, [map]);

  const setPreviousFeature = () => {
    if (previousFeature) {
      const { feature } = previousFeature;
      previousFeature.setStyle(
        includedDistricts.hasOwnProperty(feature.properties.LONG_NAME)
          ? includedDistrictColor
          : notIncludedDistrictColor
      );
    }
  }
  useEffect(setPreviousFeature, [selectedFeature]);

  return (
    <Box className={isMobile ? classes.mapAreaResponsive : classes.mapArea}>
      <div className={isMobile ? classes.mapResponsive : classes.map} id="map"></div>
    </Box>
  );
}

export default AgricultureMap;
